
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: Storytelling
* Copyright IBM Corp. 2017, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'story': 'História',
	'noDashboardFound': 'A história não pode ser recuperada. Ele não existe mais ou você não tem privilégios suficientes para visualizá-lo.',
	'noDashboardCapability': 'Você não tem a capacidade para usar histórias',
	'noDashboardPermision': 'Você não tem privilégios suficientes para visualizar esta história',
	'defaultName': 'Nova história',
	'storyProperties': 'Propriedades da história',
	'createAvDataStoryLabel': 'História',
	'createAvSlideShowLabel': 'Apresentação',
	'createAvPanAndZoomLabel': 'Jornada guiada',
	'dashboard_save_success': 'Sua história foi salva.',
	'cmEmptySelection': 'A história foi excluída. Tente salvar como uma nova história.',
	'createStoryTitle': 'Criar uma história',
	'transitionStyleTitle': 'Estilo de Transição',
	'createButton': 'Criar',
	'cancelButton': 'Cancelar',
	'dashboardResetTitle': 'Reconfigurar história',
	'dashboardResetMessage': 'Tem certeza de que deseja reconfigurar todas as mudanças aplicadas a esta história?',
	'dashboardResetToast': 'Sua história foi reconfigurada.',
	'filter_drag_and_drop_all_tabs': 'Arraste e solte dados aqui para filtrar todas as cenas.',
	'filter_drag_and_drop_current_tab': 'Arraste e solte dados aqui para filtrar esta cena.',
	'filterIconLabel_Global': 'Todos os cenários',
	'filterIconLabel_Tab': 'Esse cenário',
	'filterIconTooltip_Global': 'Todos os cenários',
	'filterIconTooltip_Tab': 'Esse cenário',
	'filterOverflowMenu_Global': 'Menu de estouro de todos os cenários',
	'filterOverflowMenu_Tab': 'Menu de estouro deste cenário',
	'renameScene': 'Renomear cena',
	'duplicateScene': 'Duplicar cena',
	'deleteScene': 'Excluir cena',
	'editTimelineHighlight': 'Editar destaque',
	'deleteTimelineHighlight': 'Excluir destaque',
	'filter_includesAll': 'Inclui todos',
	'timeline_highlight_moved_to': 'A linha do tempo %{id} movido para %{time}',
	'filter_tooltip': '[%{title}] - %{description}',
	'selectLabel': 'Selecionar',
	'newDefaultStoryName': 'História: %{modelName}',
	'exportLabel': 'Salvar',
	'exportAsLabel': 'Salvar como:',
	'exportDialogTitle': 'Salvar como uma história',
	'exportDialogFooter': 'Salvar e cancelar botões',
	'loadAfterExportLabel': 'Abrir a história após o salvamento',
	'selectTemplateLabel': 'Selecionar um gabarito',
	'outOfBoundsWarningMessage': 'Alguns widgets do painel estão fora da grade e podem não ser exibidos corretamente após a exportação.',
	'emptyExploreCardsWarningMessage': 'As placas vazias foram excluídas durante o salvamento como uma história.',
	'dashboard_export_success': 'Seu painel foi salvo com sucesso como uma história.',
	'explore_export_success': 'Sua exploração foi salva com sucesso como uma história.',
	'toastUpgradeDone': 'Sua história passou por upgrade. Salve agora para manter o desempenho adequado.',
	'navigationMarker': 'Navegação do Marcador',
	'navigateMarkers': 'Navegue marcadores',
	'navNextMarker': 'Próximo marcador',
	'navPrevMarker': 'Marcador Anterior',
	'navPrevMarkerAbbreviated': 'Marcador Anterior',
	'timelineSettingsButton': 'Opções de Reprodução',
	'autoPlay': 'Reproduzir todas as cenas',
	'loop': 'Laço',
	'refreshData': 'Atualizar no início',
	'slideshowLabel': 'Exibição de slides',
	'panAndZoomLabel': 'Jornada guiada',
	'slideShowLayoutLabel': 'Layout de exibição de slides',
	'panAndZoomLayoutLabel': 'Layout de jornada guiada',
	'panAndZoomLayoutFooter': 'Um layout de jornada guiada é uma coleção de cenas em uma única tela. Ao executar esse tipo de história, é possível a apresentação executa zoom e panoramiza em cada cena individual em ordem sequencial. Ele é diferente de um layout de slide show, em que cada cena é apresentada em uma nova tela. O layout de jornada guiada com três cenas conectadas por linhas permite criar uma sequência horizontal de cenas. Isso é útil para a exibição de uma linha de tempo.',
	'PanAndZoomLayout1': '5 cenários organizados em uma forma retangular',
	'PanAndZoomLayout2': '4 cenários organizados em uma forma de escada subindo da esquerda para a direita',
	'PanAndZoomLayout3': '6 cenários organizados em uma forma retangular',
	'PanAndZoomLayout4': '7 cenários organizados em uma forma retangular, com 6 pequenos cenários na parte superior e 1 grande cenário na parte inferior',
	'PanAndZoomLayout5': '3 cenários organizados com 2 pequenos cenários na parte superior e 1 grande cenário na parte inferior',
	'PanAndZoomLayout6': 'Uma sequência de 4 cenários organizados horizontalmente',
	'pageSelectWarning': 'Selecione um local.',
	'noSceneTransitionLabel': 'Nenhum',
	'sceneTransitionPropertyLabel': 'Transição de cenário',
	'animatedPathSceneTransitionLabel': 'Caminho animado',
	'sweepSceneTransitionLabel': 'Tempo de Acesso',
	'storyTypeLabel': 'Tipo de Histórico',
	'layoutLabel': 'Layout',
	'tabName_animation': 'Animação',
	'propAniAnimation': 'Animação',
	'propAniTypeEntrance': 'Animação de entrada',
	'propAniDirectionIn': 'Direção de entrada',
	'propAniTypeExit': 'Animação de saída',
	'propAniDirectionOut': 'Direção de saída',
	'propAniDirection': 'Direção',
	'propAniEntrance': 'Entrada',
	'propAniTypeEntranceSlideIn': 'Arrastar para dentro',
	'propAniTypeEntranceFadeIn': 'Gradação inicial',
	'propAniTypeEntrancePivotIn': 'Transformar dentro',
	'propAniTypeEntranceScaleIn': 'Escala em',
	'propAniTypeEntranceShrinkIn': 'Reduzir em',
	'propAniDirectionInLeft': 'Da Esquerda',
	'propAniDirectionInRight': 'Da direita',
	'propAniDirectionInTop': 'De Cima',
	'propAniDirectionInBottom': 'De Baixo',
	'propAniExit': 'Sair',
	'propAniTypeExitSlideIn': 'Arrastar para fora',
	'propAniTypeExitFadeIn': 'Fazer desaparecer',
	'propAniTypeExitPivotOut': 'Transformar fora',
	'propAniTypeExitScaleIn': 'Scale out',
	'propAniTypeExitExpandOut': 'Expandir',
	'propAniDirectionOutLeft': 'Para a esquerda',
	'propAniDirectionOutRight': 'Para a direita',
	'propAniDirectionOutTop': 'Para a parte superior',
	'propAniDirectionOutBottom': 'Para a parte inferior',
	'propAniEntranceTime': 'Iniciar em (segs):',
	'propAniExitTime': 'Terminar em (segs):',
	'animationNoEntranceText': 'A animação de entrada não ocorrerá se o widget estiver no início do cenário.',
	'animationNoExitText': 'A animação de saída não ocorrerá se o widget estiver no final do cenário.',
	'propAniTypeDataEntrance': 'Entrada de Dados',
	'propAniRevealDuration': 'A duração da animação de Entrada',
	'timelineAnimationProperties': 'Abrir propriedades de animação',
	'scenesPropertiesSection': 'Cenários',
	'editStoryCoachMarkTitle': 'Editar história',
	'editStoryCoachMarkContents': 'Clique no ícone de lápis para editar esta história.',
	'addDataStoryCoachMarkContents': 'Arrastar e soltar dados a partir do painel de dados em sua história.',
	'expandSceneCoachmarkTitle': 'Abrir linha de tempo',
	'expandSceneCoachmarkContents': 'Anime uma cena ajustando a visibilidade do objeto com base no horário e na duração.',
	'overviewCoachmarkTitle': 'Cenários de visão geral',
	'overviewCoachmarkContents': 'Use os cenários de visão geral para iniciar e finalizar sua história para mostrar a visão global de todos os cenários. Em um cenário de visão geral, clique e arraste um cenário para trocá-lo por outro cenário. É possível mostrar ou ocultar os cenários de visão geral nas propriedades da história.',
	'animatedPathCoachmarkTitle': 'Caminho animado',
	'animatedPathCoachmarkContents': 'Para animar um objeto de um cenário para outro, duplique um cenário com um objeto. Em seguida, mova, redimensione ou gire o objeto duplicado no novo cenário.',
	'propShowStoryOverviewFirstSlide': 'Mostrar todas as cenas no início',
	'propShowStoryOverviewLastSlide': 'Mostrar todas as cenas no término',
	'storySceneSingleCountLabel': 'Cenário 1',
	'storySceneCountLabel': '%{count} cenas',
	'storySceneRangeCountLabel': 'Cena %{index} de %{count}',
	'storySceneExpand': 'Abrir linha de tempo',
	'storySceneActionMenu': 'Menu de opções de ativação de cenário',
	'timelineRightContainerLabel': 'Grupo de controle de botão de linha de tempo',
	'timelineViewLabel': 'Linha do Tempo',
	'timelineZoomFit': 'Zoom para ajustar',
	'timelineZoomIn': 'Aumentar Zoom',
	'timelineZoomOut': 'Diminuir Zoom',
	'timelinePositionIndicator': 'Indicador de posição da linha de tempo em %{position}',
	'timelinePositionIndicatorMoveLeftTo': 'Indicador de posição linha a esquerda %{position}',
	'timelinePositionIndicatorMoveRightTo': 'Indicador de posição de linha se o direito de %{position}',
	'sceneStart': 'Acesse o início do cenário em %{position}',
	'sceneEnd': 'Acesse o término do cenário em %{position}',
	'timelineHighlightTitle': 'Destacar',
	'addTimelineHighlight': 'Incluir destaque',
	'addSceneBtnTitle': 'Incluir um novo cenário com modelo padrão',
	'addSceneChevronBtnTitle': 'Escolher um modelo de cenário',
	'timelinePlay': 'Executar',
	'timelinePause': 'Pausar',
	'sceneNavigation': 'Navegação da cena',
	'navNextScene': 'Próximo cenário',
	'navPrevScene': 'Cenário anterior',
	'navPrevSceneAbbreviated': 'Cenário anterior',
	'navExitFullScreen': 'Sair da tela cheia',
	'navToggleOverview': 'Alternar visão geral',
	'rowNumber': 'Linha %{number}',
	'overviewBtnLabel': 'Visão Geral',
	'sceneListStart': 'Início da visão geral',
	'sceneListEnd': 'Fim da visão',
	'timelineLeftHandle': 'Alça esquerda para %{name}',
	'timelineRightHandle': 'Alça direita para %{name}',
	'timelineLeftHandleNoTitle': 'identificador à esquerda',
	'timelineRightHandleNoTitle': 'identificador à direita',
	'timelineMoveLeft': 'Mova %{object} à esquerda',
	'timelineMoveRight': 'Mova %{object} certo',
	'timelineMoveWidget': 'widget de linha de tempo movido para %{newStartTime} e %{newEndTime}',
	'timelineMoveWidgetStartTime': 'horário de início de widget de linha de tempo mudado para %{newStartTime}',
	'timelineMoveWidgetEndTime': 'horário de encerramento de widget de linha de tempo mudado para %{newEndTime}',
	'timelineMoveWidgetDown': 'widget de linha de tempo movido para baixo',
	'timelineMoveWidgetUp': 'widget de linha de tempo movido para cima',
	'addSceneTitle': 'Incluir um cenário',
	'blankSceneLayout': 'Em branco',
	'titleSceneLayout': 'Título de legenda',
	'sceneLayout1': 'Título com texto ao lado de uma visualização',
	'sceneLayout2': 'Título com uma visualização',
	'sceneLayout3': 'Título com duas visualizações',
	'sceneLayout4': 'Multifinalidade',
	'sceneLayout5': 'Nenhum título com texto ao lado de uma visualização',
	'sceneLayout6': 'Multifinalidade 2 por 2',
	'sceneLayout7': 'Multifinalidade 2 ao lado 1',
	'sceneLayout8': 'Multifinalidade 1 ao lado 2',
	'sceneLayout9': 'Multifinalidade 1 por 2',
	'sceneLayout10': 'Multifinalidade 2 por 1',
	'sceneLayout11': 'Multifinalidade 4 por 1',
	'sceneLayout12': 'Multifinalidade 1 por 1 ao lado 2 por 2 por 1',
	'titleWidgetPlaceholderText': 'Insira seu título aqui',
	'subtitleWidgetPlaceholderText': 'Digite o subtítulo aqui',
	'createStoryViewTitle': 'Criar história',
	'defaultStoryName': 'Nova história',
	'screenshot_label': 'História %{title}',
	'screenshot_label_scene': 'Cenário %{sceneTitle} da história %{title}',
	'filmstripHandleOpenLabel': 'Abrir seletor de cenário',
	'filmstripHandleCloseLabel': 'Fechar seletor de cenário'
});
